skrilla.controller('bettingMarketDetailsCtrl', function ($scope, searchService, $stateParams, validationService, modalService, srefService, cacheService, uiUrlsService, bettingReferenceService, sportService, sportEventService, racingEventService, adminV2Service, customMarketService) {
    $scope.editing =false
    $scope.editCustomName = false;
    $scope.editCategoryName = false;
    $scope.outcomeTypes = bettingReferenceService.outcomeTypes()
    $scope.adminControlLevels = bettingReferenceService.adminControlLevels()
    $scope.editRules = false
    $scope.categories = bettingReferenceService.marketCategories()

    $scope.pageKey = `bettingMarkets${$stateParams.id}`;
    $scope.queryKey = `bettingMarketsQueryBets${$stateParams.id}`;
    $scope.bets = cacheService.getObjectOrElse(`${$scope.pageKey}betsTable`, []);
    $scope.tabs = [
        {title: "Market Details", active: true},
        {title: "Bets", active: false}
    ];
    $scope.newOutcomes = []

    function clickUsername(bet, field, event){
        srefService.go("userDetails", {id: bet.userId}, event);
    }

    function clickRow(bet, event){
        srefService.go("betDetails", {id: bet.id}, event);
    }
    $scope.tableData = {
        columns: [
            {title:"Username", field: "username", onClick: clickUsername, isUsernameLink: true, tags: "userTags"},
            {title: "Bet Name", field: "name"},
            {title: "Entry Id", field: "entryId", filter: {func: (it) => { return `B-${it}`}}},
            {title: "Stake", field: "stake", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Stake Source", field: "stakeSource"},
            {title: "Odds", field: "odds"},
            {title: "Potential Payout", field: "potentialPayout", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Payout", field: "paidOut", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Status", field: "status"},
            {title: "Result", field: "result"},
            {title: "Currency", field: "currency"},
            {title: "Rejection Reason", field: "reason"},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Updated At", field: "updatedAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Updated By", field: "updatedBy"}
        ],
        rows: {onClick: clickRow},
        isSkrillaTable: true,
        data: $scope.bets
    }

    $scope.getMargin = function() {
        let outcomes = $scope.outcomes?.filter(it => it.active) || [];
        if (outcomes && Object.values(outcomes).length > 0) {
            const margin = Object.values(outcomes)
                .map(value => { return 1 / value.odds })
                .reduce((acc, a) => {return acc+a})
            return Number(margin * 100).toFixed(2)
        } else {
            return 0.0
        }
    }

    $scope.editCustomNameFn = function(){
        $scope.editCustomName = !$scope.editCustomName;
    }

    $scope.editCategoryNameFn = function(){
        $scope.editCategoryName = !$scope.editCategoryName;
    }

    $scope.saveCustomName = function(){
        modalService.confirm("Are you sure you'd like to update the custom name of this market?", function(){
            const request = {
                customName: $scope.customName
            }
            sendUpdate(request).then(function(){
                $scope.editCustomName = false;
            })
        })
    }

    $scope.saveCategoryName = function(){
        modalService.confirm("Are you sure you'd like to update the category name of this market?", function(){
            const request = {
                category: $scope.category
            }
            sendUpdate(request).then(function(){
                $scope.editCategoryName = false;
            })
        })
    }


    $scope.saveNewRules = function () {
        modalService.confirm(`Are you sure you'd like to update the rules for this market?`, function () {
            let rules = {...$scope.rulesToUpdate}
            Object.entries(rules).forEach(([key, value]) => {
                if (value) {
                    rules[key] = Math.round(value * 100);
                } else {
                    delete rules[key]
                }
            })
            const request = {
                attributes: {...rules, ...$scope.attributes}
            }
            sendUpdate(request).then(function () {
                $scope.editRules = false
            })
        })
    }

    $scope.editRulesToggle = function () {
        $scope.rulesToUpdate = {
            maxStake: Math.round($scope.rules.maxStake / 100) || "",
            maxLiability: Math.round($scope.rules.maxLiability / 100) || "",
            maxUserLiability: Math.round($scope.rules.maxUserLiability / 100) || "",
        }
        $scope.editRules = !$scope.editRules
    }

    $scope.handleResponse = async function (response) {
        $scope.bettingMarketDetails = response.data;
        $scope.market = response.data.market;
        $scope.mainMarket = response.data.mainMarket;
        $scope.customName = $scope.market.customName;
        $scope.category = $scope.market.category;
        $scope.source = response.data.source;
        $scope.adminControlLevel = response.data.adminControlLevel;
        $scope.outcomes =  Object.entries(response.data.outcomes || [])
            .map(([id, outcome]) => { return { ...outcome, id}})
            .sort ((a, b) => {
            if (a.attributes?.runnerNumber && b.attributes?.runnerNumber) return parseInt(a.attributes.runnerNumber) - parseInt(b.attributes.runnerNumber)
            else return 0
        });
        $scope.campaigns = response.data.campaigns || [];
        $scope.liabilities = response.data.liabilities;
        $scope.competitors = response.data.competitors;
        $scope.rules = {};
        $scope.hasRules = false;
        $scope.attributes = {};

        $scope.bettingPath = await uiUrlsService.getSportBettingUrl($scope.market.event.sport);

        Object.entries($scope.market.attributes || {})
            .forEach(([key, value]) => {
                if (key === "maxStake" || key === "maxUserLiability" || key === "maxLiability") {
                    $scope.rules[key] = value;
                    $scope.hasRules = true;
                } else {
                    $scope.attributes[key] = value;
                }
            });
        $scope.$apply()

        //the below is very sensitive to whitespace. make sure there is no leading or trailing white space even on blank lines
        $scope.marketWidget = `
<expiring-content at="${$scope.market.event.scheduledStartTime}">
 
[![Alt Text](//images.ctfassets.net/image/path/here)](article/path/here)

<menu>
  <skrilla-button to="${$scope.bettingPath}" type="success">Bet Now</skrilla-button>
  <skrilla-button to="path/to/article" type="secondary">Learn More</skrilla-button>
</menu>

<featured-betting-event id="${$scope.market.event.eventId}" market-id="${$scope.market.id}" expanded="false"></featured-betting-event>

---

</expiring-content>

`;
        $scope.eventWidget = `
<expiring-content at="${$scope.market.event.scheduledStartTime}">
 
[![Alt Text](//images.ctfassets.net/image/path/here)](article/path/here)

<menu>
  <skrilla-button to="${$scope.bettingPath}" type="success">Bet Now</skrilla-button>
  <skrilla-button to="path/to/article" type="secondary">Learn More</skrilla-button>
</menu>

<featured-betting-event id="${$scope.market.event.eventId}" expanded="false"></featured-betting-event>

---

</expiring-content>

`;

        $scope.uiUrl = uiUrlsService.getEventBettingUrl($scope.market.event);

        Object.entries($scope.outcomes).forEach(([key, value]) => {
            value.competitor = $scope.competitors[value.competitorId];
            value.liability = $scope.liabilities[key] || {staked: 0, selectionCount:0, potentialLiability: 0 }
        })
        $scope.totalStaked = Object.values($scope.liabilities || [])
            .map(it => {
                return it.staked || 0
            })
            .reduce((acc, it) => {
                return acc + it
            }, 0) || 0

        Object.values($scope.outcomes).forEach(it => {
            if (it.liability) {
                it.liability.potentialProfit = ($scope.totalStaked) - (it.liability.staked || 0) - (it.liability.potentialLiability || 0);
            }
        })

        $scope.margin = Object.values($scope.outcomes)
            .map(it => {
                return 1 / it.odds
            })
            .reduce((acc, a) => {
                return acc + a
            })
        $scope.margin = Number($scope.margin).toFixed(2)

        $scope.title = `${$scope.market.name} on ${$scope.market.event.eventName}`
    }

    $scope.get = function() {
        searchService.get("betting/markets/" + $stateParams.id).then(function(response){
            $scope.handleResponse(response)
        })
    }
    $scope.saveAdminLevel = function() {
        searchService.put("betting/markets/" + $stateParams.id + "/adminControlLevel", {adminControlLevel: $scope.adminControlLevel}).then(function(response){
            $scope.handleResponse(response)
        })
    }
    $scope.update = function() {
        const request = {
            //api expecting a map keyed by id
            outcomes: $scope.outcomes.reduce((obj, item) => {
                return { ...obj, [item.id]: item };
            }, {}),
            newOutcomes: $scope.newOutcomes.length ? $scope.newOutcomes : null
        }
        sendUpdate(request)
        $scope.editing = false;
        $scope.newOutcomes = [];
    }

    $scope.addNewOutcome = function () {
        customMarketService.addOutcome($scope.newOutcomes)
    }

    $scope.removeNewOutcome = function (outcome) {
        $scope.newOutcomes = customMarketService.removeOutcome($scope.newOutcomes, outcome)
    }

    $scope.selectCompetitor = function (outcome, type) {
        customMarketService.selectCompetitor(outcome, $scope.market.event.sport, type);
    }

    $scope.updatePromotional = function(){
        modalService.confirm("Are you sure you'd like to update the promotional value?", function(){
            const request = {
                promotional: !$scope.market.promotional
            }
            sendUpdate(request)
        })
    }

    $scope.updateCampaignsOnly = function(){
        modalService.confirm("Are you sure you'd like to update the the campaigns only value?", function(){
            const request = {
                campaignsOnly: !$scope.market.campaignsOnly
            }
            sendUpdate(request)
        })
    }

    function sendUpdate(request){
        return searchService.put("betting/markets/" + $stateParams.id, request, "Market successfully updated").then(function(response){
            $scope.handleResponse(response)
        })
    }

    $scope.setMainMarket = function(){
        modalService.confirm("Are you sure you'd like to set this market as the main market for this event?", function(){
            searchService.put("betting/markets/" + $scope.market.id + "/mainMarket", {}, "Set as main market").then(function(response){
                modalService.dismissAll();
                $scope.get()
            })
        });
    }
    $scope.publish = function(){
        modalService.confirm("Are you sure you'd like to republish this event?", function(){
            searchService.put("betting/markets/" + $scope.market.id + "/publish", {}, "Event published").then(function(response){
                modalService.dismissAll();
            })
        });
    }
    $scope.recover = function(){
        modalService.confirm("Are you sure you'd like to trigger message recovery for this event from its provider?", function(){
            searchService.put("betting/events/" + $scope.market.event.id + "/recover", {}, "Event recovery requested").then(function(response){
                modalService.dismissAll();
                $scope.get()
            })
        });
    }
    $scope.reload = function(){
        modalService.confirm("Are you sure you'd like to reload the data for this event from its provider?", function(){
            searchService.put("betting/events/" + $scope.market.event.eventId + "/reload", {}, "Event data reloaded").then(function(response){
                modalService.dismissAll();
                $scope.get()
            })
        });
    }

    $scope.settle = function(){
        cacheService.registerObject("bettingMarketDetails", $scope.bettingMarketDetails)
        modalService.openModal("views/bettingMarketDetails/settleMarketModal.html", true, 'lg', false, true , function(){
            $scope.get();
        });
    }
    $scope.settleBets = function(){
        modalService.confirm("Are you sure you'd like to attempt settlement on any unsettled bets on this market?", function(){
            searchService.put("betting/markets/" + $scope.market.id + "/bets/settle",  {}, "Market bet settlement requested").then(function(response){
                modalService.dismissAll();
                $scope.get()
            });
        });
    }
    $scope.updateBetStop = function(){
        cacheService.registerObject("bettingMarketDetails", $scope.bettingMarketDetails)
        cacheService.registerObject("event", $scope.bettingMarketDetails.market.event)
        modalService.openModal("views/bettingMarketDetails/updateBetStopModal.html", true, 'lg', false, true , function(){
            $scope.get();
        });
    }
    $scope.eventModal = function(market){
        cacheService.registerObject("bettingMarketEvent", market.event)
        modalService.openModal("views/bettingMarketDetails/bettingMarketEventModal.html", true, 'lg', true, true , function(){
            $scope.get();
        });
    }
    $scope.rollback = function(){
        modalService.confirm("Are you sure you'd like to rollback settlement for this market?", function(){
            searchService.put("betting/markets/" + $scope.market.id + "/rollback",  {}, "Market successfully rolled back").then(function(response){
                modalService.dismissAll();
                $scope.get()
            });
        });
    }
    $scope.deactivate = function(){
        modalService.confirm("Are you sure you'd like to deactivate this market?", function(){
            searchService.put("betting/markets/" + $scope.market.id + "/deactivate",  {}, "Market successfully deactivated").then(function(response){
                modalService.dismissAll();
                $scope.get()
            });
        });
    }
    $scope.reactivate = function(){
        modalService.confirm("Are you sure you'd like to reactivate this market?", function(){
            searchService.put("betting/markets/" + $scope.market.id + "/reactivate",  {}, "Market successfully reactivated").then(function(response){
                modalService.dismissAll();
                $scope.get()
            });
        });
    }
    $scope.voidMarketSelections = function(){
        cacheService.registerObject("bettingMarketDetails", $scope.market)
        modalService.openModal("views/bettingMarketDetails/voidMarketSelectionsModal.html", true, 'lg', true, true, function(){
            modalService.dismissAll();
            $scope.get()
        });
    }
    $scope.canSettle = function(){
        return $scope.market && $scope.market.status != 'SETTLED'

    }
    $scope.canReSettle = function(){
        return $scope.market && $scope.market.status != 'SETTLED'

    }
    $scope.canDeactivate = function(){
        return $scope.market
            && $scope.market.status === 'ACTIVE'
    }
    $scope.canReactivate = function(){
        return $scope.market
            && ($scope.market.status === 'DEACTIVATED'
                || $scope.market.status === 'UNAVAILABLE'
                || $scope.market.status === 'SUSPENDED')
    }

    $scope.canRollback = function(){
        return $scope.market
            && $scope.market.status == 'SETTLED'
    }

    $scope.franchiseUrl = function(outcome){
        if (outcome.franchise)  {
            return srefService.go("franchiseDetails", {id: outcome.franchise.id});
        }
    }
    $scope.playerUrl = function(outcome){
        if (outcome.player)  {
            return srefService.go("playerDetails", {id: outcome.player.id});
        }
    }
    $scope.eventUrl = sportEventService.sportEventUrl;

    $scope.createPromotionCode = function(){
        const startDate = moment.utc($scope.market.event.scheduledStartTime).format('YYYYMMDD');
        const vs = Object.values($scope.competitors).splice(0,2).map(it => it.abbreviation || it.nickname).join("_V_")
        const slug = `${vs}_${startDate}`;
        cacheService.registerObject("entityDetails", {
            id:$scope.market.id,
            type: "BETTING_MARKET",
            name: $scope.market.name + " on " + $scope.market.event.eventName + " @ "+ $scope.market.event.scheduledStartTime,
            slug: slug
        })
        modalService.openModal("views/createBetBonusModal/createBetBonusModal.html", true, 'lg', true, true, function(){
        });
    }

    $scope.get()

    $scope.addCampaigns = function () {
        cacheService.registerObject("bettingMarketDetails", $scope.bettingMarketDetails)

        modalService.openModal("/views/addCampaignsToMarket/addCampaignsToMarket.html", true, 'lg', true, true, function () {
            $scope.get()
        })
    }

    $scope.removeCampaign = function(campaign){
        modalService.confirm("Are you sure you'd like to remove this campaign?", function() {
            searchService.deleteRequest("campaigns/" + campaign.id + "/associations/1?entityId="  + $scope.market.id, "Successfully removed association!", true)
                .then(function () {
                    $scope.get()
                })
        })

    }

    $scope.isRacingEvent = racingEventService.isRacingEvent

    $scope.openV2 = function (path, id) {
        adminV2Service.openV2(`/${path}/${id}`)
    }

});
